'use client';

import { useFetch } from '@spikemark/shared-hooks';
import { Session } from './client';

export type SessionHookResult = {
  data: Session | null;
  update: () => void;
};

export const useSession = (): SessionHookResult => {
  const { data, refetch } = useFetch<Session>('/api/auth/user', 'GET', {
    // Enable caching with a unique key
    key: 'user-session',
    // Don't bypass cache
    bypassCache: false,
  });

  return { data: data ?? null, update: refetch };
};
